/**
 * PersonaPickerModal
 *
 * Embeds <ClientPersonaLibrary mode="picker"> in a full-height Dialog so the
 * Advanced Simulation wizard and the Training Scenario editor can both reuse
 * the faceted browser for persona selection.
 */

import React from 'react';
import {
  Dialog, DialogTitle, DialogContent, DialogActions, Button, IconButton, Box, Typography
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import ClientPersonaLibrary from './ClientPersonaLibrary';

const PersonaPickerModal = ({ open, onClose, onSelect, token, preselectedKey, apiScope, title = 'Select a client persona' }) => (
  <Dialog
    open={open}
    onClose={onClose}
    fullWidth
    maxWidth="xl"
    PaperProps={{ sx: { height: '90vh' } }}
  >
    <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', pb: 1 }}>
      <Typography variant="h6">{title}</Typography>
      <IconButton onClick={onClose} size="small"><CloseIcon /></IconButton>
    </DialogTitle>
    <DialogContent dividers sx={{ p: 0, overflow: 'hidden' }}>
      <Box sx={{ p: 2, height: '100%' }}>
        <ClientPersonaLibrary
          token={token}
          mode="picker"
          onSelectPersona={onSelect}
          preselectedKey={preselectedKey}
          apiScope={apiScope}
        />
      </Box>
    </DialogContent>
    <DialogActions>
      <Button onClick={onClose}>Cancel</Button>
    </DialogActions>
  </Dialog>
);

export default PersonaPickerModal;
